<template>
  <x-page>
    <!-- 头部区域 -->
    <template #header="{ handleBackClick }">
      <!-- 搜索区域 -->
      <div :class="_.header">
        <x-icon name="back" :class="_.back" @click="handleBackClick" />

        <SearchHeader @search="handleSearch" />
      </div>
    </template>

    <div :class="_.content">
      <!-- 筛选区域 -->
      <FilterTabs @sort-change="handleSortChange" />

      <div :class="_.list">
        <x-waterfall ref="list" :load="handleLoad">
          <template #default="{ data }">
            <x-masonry :col-count="2" :gap="12">
              <ProductCard
                v-for="item in data"
                :key="item.id"
                :product="item"
              />
            </x-masonry>
          </template>
        </x-waterfall>
      </div>
    </div>
  </x-page>
</template>

<script>
  import FilterTabs from './components/FilterTabs.vue'
  import ProductCard from './components/ProductCard.vue'
  import SearchHeader from './components/SearchHeader.vue'
  import Vue from 'vue'
  import { apiCommodityCommodityCategoryCommodityList } from '@/api'

  export default Vue.extend({
    components: {
      SearchHeader,
      FilterTabs,
      ProductCard,
    },

    data: () => ({
      // 排序类型映射
      SORT_TYPE_MAP: {
        comprehensive: 0, // 综合
        sales: 1, // 销量
        price: 2, // 价格
      },

      // 排序方式映射
      SORT_ORDER_MAP: {
        asc: 0, // 升序
        desc: 1, // 降序
      },
      sortOrderByType: 0,
      sortType: 0,
    }),

    methods: {
      async handleLoad({ pageNumber }) {
        try {
          const data = await apiCommodityCommodityCategoryCommodityList(
            {
              keyword: this.keyword,
              pageIndex: pageNumber,
              pageSize: 10,
              pageType: this.$route.query.pageType || 0, // 页面类型 0多彩宝 1京东
              sortOrderByType: this.sortOrderByType,
              sortType: this.sortType,
            },
            {
              noErrorToast: true,
            },
          ).then(res => {
            return res
          })

          return data
        } catch {}
      },

      // 筛选排序 - 优化版本
      handleSortChange({ type, order }) {
        // 更新排序类型
        if (Object.prototype.hasOwnProperty.call(this.SORT_TYPE_MAP, type)) {
          this.sortType = this.SORT_TYPE_MAP[type]
        }

        // 更新排序方式
        if (Object.prototype.hasOwnProperty.call(this.SORT_ORDER_MAP, order)) {
          this.sortOrderByType = this.SORT_ORDER_MAP[order]
        }

        // 触发数据重新加载
        this.$refs.list?.reload()
      },

      // 搜索
      handleSearch(keyword) {
        this.keyword = keyword
        this.$refs.list?.reload()
      },
    },
  })
</script>

<style lang="scss" module>
  .header {
    padding: 0 12px;
    background-color: white;
    width: 100%;

    display: flex;
    align-items: center;

    .back {
      color: #333333;
      font-size: 16px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .list {
    flex: 1;
    flex-shrink: 1;
    padding: 12px;
    background-color: #f5f5f5;
    overflow-y: auto;

    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none;
    }
  }
</style>
